"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var actions_service_1 = require("./actions.service");
var ActionsComponent = (function () {
    function ActionsComponent(actionsService) {
        var _this = this;
        this.actionsService = actionsService;
        this.alt = false;
        this.showBig = false;
        this.color = 'light-gray';
        this.actionClicked = new core_1.EventEmitter();
        actionsService.actionClicked$.subscribe(function (actionItem) {
            _this.actionClicked.emit(actionItem);
        });
    }
    ActionsComponent.prototype.ngOnInit = function () {
        this.actionsService.showBig = this.showBig;
        if (!this.actionItems || this.actionItems.length === 0) {
            throw 'Actions component need actions to show';
        }
    };
    Object.defineProperty(ActionsComponent.prototype, "dropdown", {
        get: function () {
            return this.actionItems.some(function (item) {
                return item.children !== undefined;
            });
        },
        enumerable: true,
        configurable: true
    });
    return ActionsComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], ActionsComponent.prototype, "actionItems", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], ActionsComponent.prototype, "alt", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], ActionsComponent.prototype, "showBig", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ActionsComponent.prototype, "color", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], ActionsComponent.prototype, "actionClicked", void 0);
ActionsComponent = __decorate([
    core_1.Component({
        selector: 'actions',
        template: "\n    <ul class=\"actions c-{{color}}\" [ngClass]=\"{ 'actions-alt': alt, 'dropdown': dropdown }\" [class.actions]=\"!showBig\" [class.top-menu]=\"showBig\"><li *ngFor=\"let item of actionItems\" [actionItem]=\"item\"></li></ul>\n  ",
        providers: [actions_service_1.ActionsService],
    }),
    __metadata("design:paramtypes", [actions_service_1.ActionsService])
], ActionsComponent);
exports.ActionsComponent = ActionsComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/user-interface/actions/actions.component.js
// module id = 75
// module chunks = 0